/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';
import { CmsImage } from '@hyphengroup/cms-components/components/CmsImage';
import React from 'react';
import { ComponentLogoCarousel } from '$/(cms)/_modules/cmsService/types';
import { FeLink } from '$/components/FeLink';

export const LogoCarousel: React.FC<ComponentLogoCarousel> = ({
  title,
  items,
}) => {
  // Made for infinite scroll (copied from WinterCMS)
  const duplicatedItems = React.useMemo(() => {
    if (!items || !Array.isArray(items)) return [];
    return [...items, ...items];
  }, [items]);

  return (
    <div className="bg-white">
      <div className="mx-auto flex max-w-screen-2xl flex-col gap-spacing/gap/x px-0 py-8 sm:px-6 md:px-8 md:py-10 lg:px-10 lg:py-12">
        <h3 className="px-4 text-left font-bold text-gray-900 text-2xl leading-[30px] md:px-6 md:text-center md:text-[28px] md:leading-[34px] lg:px-8 lg:text-4xl lg:leading-[44px] xl:px-10">
          {title}
        </h3>
        <div className="relative">
          <div className="flex">
            {/* Two same divs with absolute for creating fade-out effect on both sides of animated element */}
            <div className="absolute left-0 top-0 z-10 hidden h-full w-8 md:block"></div>

            <div className="relative w-full overflow-hidden">
              <div className="w-[1200px] animate-infinite-scroll">
                <div className="flex w-max gap-6 lg:gap-12">
                  {duplicatedItems?.map((item, index) => {
                    const key = item?.url
                      ? `${item.url}-${index}`
                      : `logo-${index}`;
                    return (
                      <div key={key}>
                        {item?.image && (
                          <FeLink
                            href={item?.url}
                            target="_blank"
                            className="flex items-center justify-center"
                          >
                            <CmsImage
                              unoptimized
                              width={163}
                              height={48}
                              src={item?.image?.url}
                              alt={item?.image?.alternativeText ?? ''}
                              className="m-auto max-h-8 w-fit object-contain lg:max-h-12"
                            />
                          </FeLink>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className="absolute left-0 top-0 z-10 hidden h-full w-8 md:block"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
